/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { func } from 'prop-types';

import {
    googlePayPluginConfig,
} from '../../../../../../../../state/ducks/Payment/plugins/GooglePay/GooglePay-Helper';
import withScript from '../../../../../../../../lib/scriptLoader';

const LoadGooglePay = (props) => {
    const { isScriptLoaded, isScriptLoadSucceed, render } = props;
    return (
        render({
            isScriptLoaded,
            isScriptLoadSucceed,
        })
    );
};

LoadGooglePay.propTypes = {
    render: func.isRequired,
};

export default withScript(googlePayPluginConfig.sdkURL, false, true)(LoadGooglePay);
